import { gql } from '@apollo/client';

export const fetchInvoicesForPaymentMethod = gql`
  query fetchInvoicesForPaymentMethod(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    invoiceGroupsForPaymentMethod(id: $id) {
      id
      paymentMethodBillingGroupIds
      invoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          status
          invoiceNumber
          sourceSystem
          paymentMethod
          creditCardMaskedNumber
          dueDate
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          purchaseOrderNumber
          pdfLink
          refunds {
            id
            type
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          dunningStatus {
            errorCode
          }
          shipTo {
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
            fullName
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
